import TravelRequirementsManagerContainer from './TravelRequirementsManagerContainer';

export default TravelRequirementsManagerContainer;
